// extracted by mini-css-extract-plugin
export default {"truncate":"Content_truncate__GhakD"};